export const formatDate = (timestamp) => {
  return new Date(timestamp * 1000)
    .toLocaleString('en-US', {
      timeZone: 'UTC',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZoneName: 'short'
    })
    .replace(',', ' - ')
}
